import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60da79fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))

import { computed, ref } from 'vue';
import { useInfo } from '@/store';
import { isPC } from '@/hooks/useCheck';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Pagination } from 'swiper';
import { SwiperEvents, SwiperModule } from 'swiper/types';
import 'swiper/swiper-bundle.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'Swiper',
  props: {
    list: null,
    prefix: null,
    module: null,
    loop: { type: Boolean },
    autoplay: null
  },
  setup(__props: any) {

const props = __props as {
  list: {
    [key: string]: any;
  }[];
  prefix: string;
  module?: SwiperModule;
  loop?: boolean;
  autoplay?: {
    [key: string]: boolean | number;
  };
}

_useCssVars(_ctx => ({
  "4ed81c77": (_unref(dotPagination).mobile),
  "6992fe69": (_unref(leftArrow).pc),
  "4c6f7e2a": (_unref(rightArrow).pc)
}))


let modules: SwiperModule[];
if (props.module) {
  modules = [Pagination, props.module];
} else {
  modules = [Pagination];
}
const pagination = {
  el: '.swiper-pagination',
  clickable: true,
  renderBullet: function (_index: number, className: string) {
    return `<span class="${className}"></span>`;
  },
};
const btn = ref('');
const showBtn = (event: MouseEvent) => {
  if (!isPC.value || props.list.length < 2) return;
  if (event.type === 'mouseleave') {
    btn.value = '';
  } else {
    if (event.clientX < window.innerWidth / 2) {
      btn.value = 'prev';
    } else {
      btn.value = 'next';
    }
  }
};
const swiperRef = ref<SwiperEvents | null>(null);
const slide = (swiper, event: MouseEvent | TouchEvent | PointerEvent) => {
  if ((event.target as Element).tagName !== 'DIV') return;
  if (!isPC.value || props.list.length < 2) return;
  if (btn.value === 'next') {
    if (!swiper.rtl) {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }
  }
  if (btn.value === 'prev') {
    if (!swiper.rtl) {
      swiper.slidePrev();
    } else {
      swiper.slideNext();
    }
  }
};
const checkDirection = computed(() => {
  const lang = document.documentElement.lang;
  return lang === 'ar' || lang === 'ur' ? 'rtl' : 'ltr';
});
const { getImg } = useInfo();
const dotPagination = computed(() => ({
  mobile: `url(${getImg('home_mobile_pagination')})`,
}));
const leftArrow = computed(() => ({
  pc: `url(${getImg('home_pc_left_arrow')})`,
}));
const rightArrow = computed(() => ({
  pc: `url(${getImg('home_pc_right_arrow')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "swiperRef",
    ref: swiperRef
  }, [
    _createVNode(_unref(Swiper), {
      pagination: pagination,
      modules: _unref(modules),
      loop: __props.loop,
      autoplay: __props.autoplay,
      allowTouchMove: !_unref(isPC),
      dir: _unref(checkDirection),
      onMousemove: showBtn,
      onMouseleave: showBtn,
      onClick: slide
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['bg', btn.value])
              }, [
                _createElementVNode("img", {
                  class: "bg--pc",
                  src: item[`${__props.prefix}Landscape`],
                  alt: ""
                }, null, 8, _hoisted_1),
                _createElementVNode("img", {
                  class: "bg--mobile",
                  src: item[`${__props.prefix}Portrait`],
                  alt: ""
                }, null, 8, _hoisted_2)
              ], 2),
              _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(item)))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _hoisted_3
      ]),
      _: 3
    }, 8, ["modules", "loop", "autoplay", "allowTouchMove", "dir"])
  ], 512))
}
}

})